import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogFooter,
  DialogClose,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { useTranslation } from "react-i18next";
import { ScrollArea } from "./ui/scroll-area";
import { FileText } from "lucide-react";

interface DisclaimerProps {
  triggerText?: string;
}

const Disclaimer = ({ triggerText }: DisclaimerProps) => {
  const { t } = useTranslation("common-page");
  return (
    <>
      <Dialog>
        <DialogTrigger asChild>
          <span className="underline cursor-pointer hover:text-[--accent-primary] transition-colors text-[--accent-primary]">
            {triggerText || t("notice")}
          </span>
        </DialogTrigger>
        <DialogContent className="max-w-4xl max-h-[85vh] flex flex-col">
          <DialogHeader className="border-b border-border/50 pb-4 flex flex-row items-center gap-4">
            <div className="flex items-center justify-center p-2 rounded-lg bg-[--accent-primary]/15">
              <FileText className="h-6 w-6 text-white" />
            </div>
            <div className="flex-1">
              <DialogTitle className="text-xl font-bold text-left">
                Disclaimer &amp; Risk Notice
              </DialogTitle>
              <p className="text-xs text-muted-foreground text-left mt-0.5">
                Last updated: July 2026
              </p>
            </div>
          </DialogHeader>

          <ScrollArea className="h-[50vh] pr-4 my-4">
            <div className="space-y-6 text-sm leading-relaxed text-slate-300 text-left">
              <div className="bg-[#0c1938]/30 border border-[#1d3570]/30 rounded-xl p-4 text-slate-300">
                <p>Level2 is an automated financial market analysis service.</p>
              </div>

              <div className="space-y-3">
                <ul className="list-disc pl-5 space-y-4 text-slate-400">
                  <li>
                    There are potential risks relating to investing and trading.
                    You must be aware of such risks and familiarise yourself in
                    regard to such risks and seek independent advice relating
                    thereto. You should not trade with money that you cannot
                    afford to lose.
                  </li>
                  <li>
                    The Level2 service and its content should not be construed
                    as a solicitation to invest and/or trade. You should seek
                    independent advice in this regard.
                  </li>
                  <li>
                    Past performance is not indicative of future performance. No
                    representation is being made that any results discussed
                    within the service and its related media content will be
                    achieved.
                  </li>
                  <li>
                    All opinions, news, research, analyses, prices or other
                    information is provided as general market commentary and not
                    as investment advice. Level2, their members, shareholders,
                    employees, agents, representatives and resellers do not
                    warrant the completeness, accuracy or timeliness of the
                    information supplied, and they shall not be liable for any
                    loss or damages, consequential or otherwise, which may arise
                    from the use or reliance of the Level2 service and its
                    content.
                  </li>
                </ul>
              </div>
            </div>
          </ScrollArea>

          <DialogFooter className="border-t border-border/50 pt-4 flex justify-end">
            <DialogClose asChild>
              <Button
                type="button"
                className="bg-[--accent-primary] text-white hover:bg-[--accent-primary]/90 px-6 py-2 rounded-md transition-all duration-300"
              >
                Accept &amp; Close
              </Button>
            </DialogClose>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
export default Disclaimer;
